import { render, staticRenderFns } from "./GostergeTablolari.vue?vue&type=template&id=3e983df6"
import script from "./GostergeTablolari.vue?vue&type=script&lang=js"
export * from "./GostergeTablolari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports